const memberForm = () => {
	const form = document.querySelector('.js-member-form');

	if (form) {
		const button = form.querySelectorAll('[data-to-step]')
		const back = form.querySelector('.js-member-form-back')
		const giftAid = form.querySelector('.js-member-form-giftaid')
		const giftAidToggle = form.querySelector('.js-member-form-giftaid-toggle')
		const fieldsetType = form.querySelector('#member-form-type')
		const fieldsetFrequency = form.querySelector('#member-form-frequency')
		const fieldsetDonation = form.querySelector('#member-form-donation')
		const fieldsetPaymentMonthly = form.querySelector('#member-form-payment-monthly')
		const fieldsetPaymentAnnual = form.querySelector('#member-form-payment-annual')
		const inputType = form.querySelectorAll('[name="member-form-type"]')
		const inputFrequency = form.querySelectorAll('[name="member-form-frequency"]')
		const inputDonationOther = form.querySelector('[name="member-form-donation-other"]')
		const inputGiftAid = form.querySelector('[name="member-form-gift-aid"]')
		const clearDonation = form.querySelector('.js-member-form-donation-option-clear')
		const submit = form.querySelectorAll('.js-submit-form')
		let inputDonation = form.querySelectorAll('[name="member-form-donation"]')
		const loading = form.querySelector('.js-member-form-loading')

		const $step = form.querySelector('.js-member-form-step')
		const $wagedPrice = form.querySelector('.js-member-form-waged-price')
		const $unwagedPrice = form.querySelector('.js-member-form-unwaged-price')
		const $monthlyPrice = form.querySelector('.js-member-form-monthly-price')
		const $annualPrice = form.querySelector('.js-member-form-annual-price')
		const $frequency = form.querySelectorAll('.js-member-form-frequency')
		const $donationOptions = form.querySelectorAll('.js-member-form-donation-options')
		const $donationOptionOne = form.querySelectorAll('.js-member-form-donation-option-one')
		const $donationOptionTwo = form.querySelectorAll('.js-member-form-donation-option-two')
		const $donationOptionThree = form.querySelectorAll('.js-member-form-donation-option-three')
		const $donationOptionFour = form.querySelectorAll('.js-member-form-donation-option-four')
		const $frequencyPrice = form.querySelectorAll('.js-member-form-frequency-price')
		const $donationPrice = form.querySelectorAll('.js-member-form-donation-price')
		const $totalPrice = form.querySelectorAll('.js-member-form-total-price')
		const $giftAidPrice = form.querySelectorAll('.js-member-form-gift-aid-price')
		const $giftAid = form.querySelector('.js-member-form-gift-aid')
		const $paymentMethod = form.querySelector('.js-member-form-payment-method');
		const countryIdInput = form.querySelector('.js-countryId-input');

		const validateForm = (form, onSuccess) => {
			const data = new FormData(form);
			const errorsContainer = form.querySelector('.js-member-form-errors');
			let requiredFields = [];

			errorsContainer.innerHTML = null;

			for (let entry of data) {
				if (entry[0].indexOf('member-form-') !== 0) {
					const input = form.querySelector('#member-form-contact-' + entry[0]);

					if (input) {
						const field = input.parentNode;
						const errorEl = field.querySelector('.js-member-form-input-error');

						input.setAttribute('aria-invalid', false);
						field.classList.remove('field--error');

						if (errorEl) {
							errorEl.innerHTML = null;
						}

						if (input.getAttribute('aria-required') === 'true' && input.value === '') {
							requiredFields.push({
								input: input,
								type: 'required'
							});
							input.setAttribute('aria-invalid', true);
						} else {
							if (input.type === 'email' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(input.value)) {
								requiredFields.push({
									input: input,
									type: 'invalid'
								});
								input.setAttribute('aria-invalid', true);
							}
						}
					}
				}
			}

			if (requiredFields.length > 0) {
				let listHtml = ''

				requiredFields.forEach(item => {
					const field = item.input.parentNode;
					const label = field.querySelector('label')
					const errorEl = field.querySelector('.js-member-form-input-error');

					field.classList.add('field--error');

					if (label) {
						listHtml += `<li class='js-member-form-error' data-input='${item.input.id}'><button type="button">${label.dataset.label ? label.dataset.label : label.innerHTML} is ${item.type}</button></li>`
					}

					if (errorEl) {
						errorEl.innerHTML = `${label.dataset.label ? label.dataset.label : label.innerHTML} is ${item.type}`
					}
				});

				let html = `<p>Please fix the following errors before submitting.</p>`;

				if (listHtml !== '') {
					html += `<ul>${listHtml}</ul>`;
				}

				errorsContainer.innerHTML = html;

				focusOnEl(errorsContainer);

				form.querySelectorAll('.js-member-form-error').forEach(error => {
					error.addEventListener('click', () => {
						const input = form.querySelector('#' + error.dataset.input);

						if (input) {
							input.focus();
							focusOnEl(input);
						}
					});
				});
			} else {
				onSuccess(data)
			}
		}

		const focusOnEl = (el) => {
			let focusTarget;

			if (el.tagName === 'INPUT' || el.tagName === 'SELECT') {
				focusTarget = el;
			} else {
				const button = el.querySelector('button');

				if (button) {
					focusTarget = button;
				}
			}

			if (focusTarget) {
				focusTarget.focus();
			}

			const scrollPosition = window.pageYOffset + el.getBoundingClientRect().top;
			
			const elements = [
				document.querySelector('.navigation-bar-holder'),
				document.querySelector('.condition-sub-nav')
			];

			let elHeight = 0;

			elements.forEach(el => {
				if (el) {
					elHeight += el.clientHeight;
				}
			});

			const topHeight = scrollPosition - (elHeight + 30);
			
			window.scroll(0, topHeight);
		}

		button.forEach((el) => {
			el.addEventListener('click', () => {
				const stepId = parseInt(el.dataset.toStep)

				if (stepId === 5) {
					validateForm(form, (data) => {
						updateStep(stepId)
					})
				} else if (stepId > 0) {
					updateStep(stepId)
				}
			})
		})

		back.addEventListener('click', () => {
			history.back()
		})

		const updateStep = (stepId, ignorePushState) => {
			// Update the dataset of the component
			form.dataset.viewingStep = stepId

			// Update the html of the $step element
			if ($step) {
				$step.innerHTML = stepId
			}

			window.scroll(0, 0);
			form.querySelector(`[data-step="${stepId}"]`).focus()

			if (!ignorePushState) {
				const url = new URL(location);
				history.pushState({
					step: stepId
				}, '', url);
			}
		}

		addEventListener('popstate', (event) => {
			const step = event?.state?.step
			
			if (step) {
				updateStep(step, true)
			}
		})

		const prepareForm = () => {
			if (fieldsetType) {
				// Update the html of the $wagedPrice element
				if ($wagedPrice) {
					$wagedPrice.innerHTML = fieldsetType.dataset.wagedPrice
				}
				// Update the html of the $unwagedPrice element
				if ($unwagedPrice) {
					$unwagedPrice.innerHTML = fieldsetType.dataset.unwagedPrice
				}
			}
		}

		const capitalize = (word) => {
			const loweredCase = word.toLowerCase()

			return word[0].toUpperCase() + loweredCase.slice(1)
		}

		const watchForm = () => {
			const button = document.querySelector('[data-to-step="2"]')

			// Type input changes
			inputType.forEach((el) => {
				el.addEventListener('change', () => {
					if (el.value === 'waged') {

						// If it's a waged type:
						// - Disable the button
						// - Show the frequency fieldset

						if (button) {
							button.setAttribute('disabled', true)
						}
						if (fieldsetFrequency) {
							fieldsetFrequency.removeAttribute('hidden')
						}
						const frequency = [...inputFrequency].filter((el) => {
							return el.checked
						})

						if (frequency.length === 1) {
							frequency[0].checked = false
							frequency[0].dispatchEvent(new Event('change'))
						}

						if (fieldsetFrequency) {
							// Update the html of the $monthlyPrice element
							if ($monthlyPrice) {
								$monthlyPrice.innerHTML = fieldsetFrequency.dataset.wagedMonthlyPrice
							}
							// Update the html of the $annualPrice element
							if ($annualPrice) {
								$annualPrice.innerHTML = fieldsetFrequency.dataset.wagedAnnualPrice
							}
						}
					} else {
						
						// If it's not a waged type:
						// - Enable the button
						// - Hide the frequency fieldset
						// - Uncheck the frequency input (if it was checked)

						if (button) {
							button.removeAttribute('disabled')
						}
						if (fieldsetFrequency) {
							fieldsetFrequency.hidden = true
						}
						const frequency = [...inputFrequency].filter((el) => {
							return el.value === 'annual'
						})

						if (frequency.length === 1) {
							frequency[0].checked = true
							frequency[0].dispatchEvent(new Event('change'))
						}
					}

					resetDonations()
				})
			})

			// Frequency input changes
			inputFrequency.forEach((el) => {
				el.addEventListener('change', () => {

					const value = el.value

					$frequency.forEach((el) => {
						el.innerHTML = value
					})
					
					// Enable the button
					if (button && el.checked) {
						button.removeAttribute('disabled')
					}

					resetDonations()
					setFrequencyPrice(value)
					setPaymentOptions(value)
					setDonationOptions(value)
				})
			})

			clearDonation.addEventListener('click', resetDonations)

			inputDonationOther.addEventListener('input', () => {
				const value = parseFloat(inputDonationOther.value)
				const isInvalid = isNaN(value) || (!isNaN(value) && value < 0)

				if (isInvalid) {
					resetDonationOther()
					updateDonationPrice(0)
					clearDonation.setAttribute('disabled', true)
				} else {
					resetDonation()
					updateDonationPrice(inputDonationOther.value)
					clearDonation.removeAttribute('disabled')
				}
			})

			giftAidToggle.addEventListener('click', () => {
				if (giftAid.classList.contains('member-form__gift-aid--active')) {
					giftAid.classList.remove('member-form__gift-aid--active')
					giftAidToggle.setAttribute('aria-label', 'Expand')
				} else {
					giftAid.classList.add('member-form__gift-aid--active')
					giftAidToggle.setAttribute('aria-label', 'Collapse')
				}
			})

			inputGiftAid.addEventListener('change', () => {
				$giftAid.value = inputGiftAid.checked
			})

			submit.forEach((el) => {
				el.addEventListener('click', () => {
					$paymentMethod.value = el.dataset.paymentMethod
					loading.removeAttribute('hidden')
					form.submit()
				})
			})
		}

		const setFrequencyPrice = (frequency) => {
			const type = [...inputType].filter((el) => {
				return el.checked
			})

			if (type.length === 1) {
				if (type[0].value === 'waged') {
					updateFrequencyPrice(fieldsetFrequency.dataset[`waged${capitalize(frequency)}Price`])
				} else if (frequency === 'annual') {
					updateFrequencyPrice(fieldsetFrequency.dataset[`unwaged${capitalize(frequency)}Price`])
				}
			}
		}

		const setPaymentOptions = (frequency) => {
			if (frequency === 'monthly') {
				if (fieldsetPaymentMonthly) {
					fieldsetPaymentMonthly.removeAttribute('hidden')
				}

				if (fieldsetPaymentAnnual) {
					fieldsetPaymentAnnual.hidden = true
				}
			} else {
				if (fieldsetPaymentMonthly) {
					fieldsetPaymentMonthly.hidden = true
				}

				if (fieldsetPaymentAnnual) {
					fieldsetPaymentAnnual.removeAttribute('hidden')
				}
			}
		}

		const setDonationOptions = (frequency) => {
			var options = fieldsetDonation.dataset[`${frequency}PriceOptions`].split(',');

			if (fieldsetDonation) {
				var donationOptionsHtml = "";
				var index = 1;

				options.forEach((el) => {
					donationOptionsHtml += `<div class="member-form__donation-field"> <input type="radio" name="member-form-donation" id="member-form-donation-option-${index}" value="${options[index-1]}" aria-labelledby="l-member-form-donation-option-${index}" class="js-member-form-donation-option-${index}" /> <label id="l-member-form-donation-${index}" for="member-form-donation-option-${index}"> £<span class="js-member-form-donation-option-${index}">${options[index-1]}</span> </label> </div>`
					index++;
				})

				$donationOptions.forEach((el) => {
					el.innerHTML = donationOptionsHtml;
				})

				inputDonation = form.querySelectorAll('[name="member-form-donation"]');
				
				inputDonation.forEach((el) => {
					el.addEventListener('change', () => {
	
						if (el.checked) {
							clearDonation.removeAttribute('disabled')
							resetDonationOther()
						} else {
							clearDonation.setAttribute('disabled', true)
						}
	
						updateDonationPrice(el.checked ? el.value : 0)
					})
				})

				// Update the html of the $donationOptionOne element
				$donationOptionOne.forEach((el) => {
					if (el.tagName === 'INPUT') {
						el.value = options[0]
					} else {
						el.innerHTML = options[0]
					}
				})
				// Update the html of the $donationOptionTwo element
				$donationOptionTwo.forEach((el) => {
					if (el.tagName === 'INPUT') {
						el.value = options[1]
					} else {
						el.innerHTML = options[1]
					}
				})
				// Update the html of the $donationOptionThree element
				$donationOptionThree.forEach((el) => {
					if (el.tagName === 'INPUT') {
						el.value = options[2]
					} else {
						el.innerHTML = options[2]
					}
				})
				// Update the html of the $donationOptionFour element
				$donationOptionFour.forEach((el) => {
					if (el.tagName === 'INPUT') {
						el.value = options[3]
					} else {
						el.innerHTML = options[3]
					}
				})
			}
		}

		const updateDonationPrice = (value) => {
			$donationPrice.forEach((el) => {
				if (el.tagName === 'INPUT') {
					el.value = value
				} else {
					el.innerHTML = value
				}
			})

			updateTotalPrice()
		}

		const updateFrequencyPrice = (value) => {
			$frequencyPrice.forEach((el) => {
				if (el.tagName === 'INPUT') {
					el.value = value
				} else {
					el.innerHTML = value
				}
			})

			updateTotalPrice()
		}

		const updateTotalPrice = () => {
			let value = 0

			const prices = [...$frequencyPrice, ...$donationPrice].filter((el) => {
				return el.tagName === 'INPUT'
			})

			prices.forEach((el) => {
				value += parseInt(el.value * 100) / 100
			})

			$totalPrice.forEach((el) => {
				if (el.tagName === 'INPUT') {
					el.value = value
				} else {
					el.innerHTML = value
				}
			})

			updateGiftAidPrice(formatPrice(value * 1.25))
		}

		const formatPrice = (value) => {
			const str = value.toString().split('.')
			let price = `${str[0]}`

			if (str.length > 1) {
				let pence = str[1].slice(0, 2)

				if (pence.length === 1) {
					pence += 0
				}

				price += `.${pence}`
			} else {
				price += `.00`
			}

			return price
		}

		const updateGiftAidPrice = (value) => {			
			$giftAidPrice.forEach((el) => {
				if (el.tagName === 'INPUT') {
					el.value = value
				} else {
					el.innerHTML = value
				}
			})
		}

		const resetDonation = () => {
			const donation = [...inputDonation].filter((el) => {
				return el.checked
			})

			if (donation.length === 1) {
				donation[0].checked = false
				donation[0].dispatchEvent(new Event('change'))
			}
		}

		const resetDonationOther = () => {
			inputDonationOther.value = ''
		}

		const resetDonations = () => {
			resetDonation()
			resetDonationOther()
			clearDonation.setAttribute('disabled', true)
			updateDonationPrice(0)
		}

		const fetchCountries = (onSuccess) => {
			const request = new XMLHttpRequest();
			request.open('GET', '/umbraco/api/Countries/Get', true);
	 
			request.onload = () => {
				if (request.status >= 200 && request.status < 400) {
					return onSuccess(JSON.parse(request.responseText));
				}
			}
	 
			request.send();
		}
	 
		const populateCountries = (countries) => {
			let options = '';
	 
			countries.forEach(option => {
				const selected = option.name === 'United Kingdom' ? 'selected=selected' : '';
				options += `<option value='${option.countryId}' ${selected}>${option.name}</option>`;
			})
	 
			if (countryIdInput && options !== '') {
				countryIdInput.innerHTML = options;
			}
		}

		if (countryIdInput) {
			fetchCountries((countries) => {
				populateCountries(countries)
			})
		}

		prepareForm()
		watchForm()
		updateStep(1)
	}
};

memberForm()